export default __webpack_public_path__ + "static/media/sprite.a075d2ba.svg";